// extracted by mini-css-extract-plugin
export default {"container":"IconButton_container__sep-y","icon":"IconButton_icon__YFTzi"};